import { BaseAssociationModelInterface, IdentityInterface, ModelInterface } from "@nts/std/interfaces"
import { DomainModelCollection } from "../domain-model-collection"



/**
 * Base class per le collection di associazioni per le relazioni N:M
 */
export class BaseNMCollection<

    /**
     * Model che rappresenta l'associazione
     */
    TItem extends BaseAssociationModelInterface<TItemIdentity>, 

    /**
     * Identity del model che rappresenta l'associazione
     */
    TItemIdentity extends IdentityInterface, 

    /**
     * Model dell'estremità N della relazione
     */
    TLeftExternal extends ModelInterface<TLeftExternalIdentity>, 

    /**
     * Identity del model dell'estremità N della relazione
     */
    TLeftExternalIdentity extends IdentityInterface,

    /**
     * Model dell'estremità M della relazione
     */
    TRightExternal extends ModelInterface<TRightExternalIdentity>, 

    /**
     * Identity del model dell'estremità M della relazione
     */
    TRightExternalIdentity extends IdentityInterface
> extends DomainModelCollection<TItem, TItemIdentity> {

}